import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="28ufm24yk52fw">
      <MetaPixel data-id="element-1" data-mp="28te3zgj4jfoo" />
      <CountdownBar data-id="element-2" data-mp="28sur4e8bzhhi" />
      <main data-id="element-3" data-mp="28s2x37udtrtc">
        <Hero data-id="element-4" data-mp="23vcikoy874a1" />
        <StatsBar data-id="element-5" data-mp="23vupqgmff2wq" />
        <Difference data-id="element-6" data-mp="23u9v6r043jyv" />
        <Recognize data-id="element-7" data-mp="23ut97wmn5o7m" />
        <WhatsInside data-id="element-8" data-mp="23ti8y6semyl9" />
        <InsidePages data-id="element-9" data-mp="3ik7fce9tu7pl" />
        <Bonuses data-id="element-10" data-mp="3ikqwvtvkeu33" />
        <Offer data-id="element-11" data-mp="3ij61y35c994p" />
        <Guarantee data-id="element-12" data-mp="3ijpe138b53at" />
        <Testimonials data-id="element-13" data-mp="3ii4q3wgi0ilx" />
        <Faq data-id="element-14" data-mp="3ml13n8r6loj0" />
        <FinalCta data-id="element-15" data-mp="3mkrgru1fnxhj" />
      </main>
      <Footer data-id="element-16" data-mp="3mjq27fl7ksv2" />
    </div>;
}